module.exports = __webpack_public_path__ + "static/media/blog-15.d21ac97b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog-15.webp
// module id = 286
// module chunks = 0